import { render, staticRenderFns } from "./AdminBookings.vue?vue&type=template&id=c202d5e2"
import script from "./AdminBookings.vue?vue&type=script&lang=js"
export * from "./AdminBookings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports